<template>
	<span class="bulk-actions">
		<select v-model="key" class="omapi-input__select">
			<option value="">Bulk Actions</option>
			<option value="delete">Delete</option>
			<option value="email">Email</option>
		</select>
		<core-button
			:disabled="!isBulk || '' === key"
			color="white"
			size="small"
			type="secondary"
			button-type="button"
			@click="doBulkAction"
			>Apply</core-button
		>
	</span>
</template>

<script lang="js">
export default {
	props: {
		/**
		 * The Bulk Action key
		 */
		actionKey: {
			type: String,
			default: '',
		},
		/**
		 * Whether we are in bulk edit mode.
		 */
		isBulk: Boolean,
	},
	data() {
		return {
			key: this.actionKey || '',
		};
	},
	watch: {
		actionKey() {
			this.key = this.actionKey || '';
		},
		key(newVal) {
			this.$emit('setAction', newVal);
		},
	},
	methods: {
		doBulkAction() {
			switch (this.key) {
				case 'email':
					this.$modal.show('email-upsell');
					break;
				case 'delete':
				default:
					this.$modal.show('bulk-delete-modal');
					break;
			}
		},
	},
};
</script>

<style lang="scss">
.omapi-screen .omapi-monsterleads__table .bulk-actions {
	margin-right: 20.5px;
	display: flex;
	select {
		min-width: 167px;
		margin-right: 6px;
		font-size: 13px;
		line-height: 1.3em;
	}
	button {
		padding: 6px 12px;
	}
}
</style>
